exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".editor-input {\n  border-width: 0px;\n  border-bottom-width: 1px;\n  border-radius: 0px;\n  border-color: #1976D2;\n  width: 80%; }\n  .editor-input:focus {\n    border-width: 0px;\n    border-bottom-width: 1px;\n    border-radius: 0px;\n    outline: none; }\n\n.attribute-label {\n  font-weight: bold; }\n\n.device-info {\n  padding: 2px; }\n  .device-info div {\n    text-align: left; }\n\n.ui-panel .ui-panel-content {\n  padding: 2px; }\n\np-toolbar .ui-widget-header {\n  background: transparent;\n  box-shadow: none;\n  padding: 0px; }\n\n.device-list-header {\n  text-align: right; }\n\np-panel.selected .ui-widget-content {\n  background: lightblue; }\n\n.ui-datagrid .ui-datagrid-header {\n  padding: 2px 3px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/bs_work/toMigrate_litePortal/src/app/component-module/device-list/device-list.component.scss
// module id = ../../../../../src/app/component-module/device-list/device-list.component.scss
// module chunks = main